module.exports = __webpack_public_path__ + "img/应用一体化.f6054ac7.png";